export const BRAND = {
    name: "L'Atelier du meuble",
    suffix: "by RO Concept",
    logo: "https://customer-assets.emergentagent.com/job_bespoke-design-ro/artifacts/111tmn7a_logo.png",
    address: "Avenue d'Auderghem 352, 1040 Etterbeek",
    phone: "0484 42 45 08",
    email: "contact@meuble-etterbeek.be",
    hours: "Lun – Ven · 9h00 – 18h00",
    socials: {
        instagram: "https://instagram.com/",
        facebook: "https://www.facebook.com/people/Bed-Sofa/61579081103675/",
        linkedin: "https://linkedin.com/",
    },
};

export const IMAGES = {
    hero: "https://images.pexels.com/photos/27059630/pexels-photo-27059630.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000",
    kitchen: "https://images.pexels.com/photos/8142046/pexels-photo-8142046.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    dressing: "https://images.pexels.com/photos/6580406/pexels-photo-6580406.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    renovation: "https://images.unsplash.com/photo-1680416124510-5eae1beca412?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhcGFydG1lbnQlMjByZW5vdmF0aW9uJTIwaW50ZXJpb3IlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc5NzE1MzYyfDA&ixlib=rb-4.1.0&q=85",
    furniture: "https://images.unsplash.com/photo-1724582586458-a51791349977?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxiZWxnaWFuJTIwc3R5bGUlMjBtaW5pbWFsaXN0JTIwbHV4dXJ5JTIwbGl2aW5nJTIwcm9vbSUyMGludGVyaW9yfGVufDB8fHx8MTc3OTcxNTM2Mnww&ixlib=rb-4.1.0&q=85",
    cta: "https://images.unsplash.com/photo-1725257928373-dc6d2ac7b145?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0JTIwbHV4dXJ5JTIwbW9kZXJuJTIwa2l0Y2hlbiUyMGludGVyaW9yfGVufDB8fHx8MTc3OTcxNTM2Mnww&ixlib=rb-4.1.0&q=85",
};

// Gallery items with category for filtering
export const GALLERY = [
    {
        id: "g1",
        category: "Cuisine",
        title: "Cuisine en chêne brossé",
        location: "Uccle, Bruxelles",
        src: "https://images.unsplash.com/photo-1622372738946-62e02505feb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwbHV4dXJ5JTIwbW9kZXJuJTIwa2l0Y2hlbiUyMGludGVyaW9yfGVufDB8fHx8MTc3OTcxNTM2Mnww&ixlib=rb-4.1.0&q=85",
    },
    {
        id: "g2",
        category: "Rangement",
        title: "Dressing contemporain",
        location: "Ixelles, Bruxelles",
        src: "https://images.unsplash.com/photo-1708397016786-8916880649b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBtb2Rlcm4lMjB3YWxrJTIwaW4lMjBjbG9zZXQlMjB3YXJkcm9iZSUyMGludGVyaW9yfGVufDB8fHx8MTc3OTcxNTM2Mnww&ixlib=rb-4.1.0&q=85",
    },
    {
        id: "g3",
        category: "Canapés",
        title: "Canapé sur mesure",
        location: "Etterbeek, Bruxelles",
        src: "https://images.unsplash.com/photo-1680770638423-6d4c1089bd7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBhcGFydG1lbnQlMjByZW5vdmF0aW9uJTIwaW50ZXJpb3IlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc5NzE1MzYyfDA&ixlib=rb-4.1.0&q=85",
    },
    {
        id: "g4",
        category: "Salon",
        title: "Salon minimaliste",
        location: "Woluwe, Bruxelles",
        src: "https://images.pexels.com/photos/27059630/pexels-photo-27059630.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        id: "g5",
        category: "Cuisine",
        title: "Îlot central marbre",
        location: "Saint-Gilles, Bruxelles",
        src: "https://images.pexels.com/photos/8142046/pexels-photo-8142046.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        id: "g6",
        category: "Rangement",
        title: "Penderie sur mesure",
        location: "Schaerbeek, Bruxelles",
        src: "https://images.pexels.com/photos/6580406/pexels-photo-6580406.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        id: "g7",
        category: "Canapés",
        title: "Banquette d'angle contemporaine",
        location: "Etterbeek, Bruxelles",
        src: "https://images.unsplash.com/photo-1680416124510-5eae1beca412?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhcGFydG1lbnQlMjByZW5vdmF0aW9uJTIwaW50ZXJpb3IlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc5NzE1MzYyfDA&ixlib=rb-4.1.0&q=85",
    },
    {
        id: "g8",
        category: "Salon",
        title: "Meuble TV intégré",
        location: "Auderghem, Bruxelles",
        src: "https://images.unsplash.com/photo-1725257928373-dc6d2ac7b145?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0JTIwbHV4dXJ5JTIwbW9kZXJuJTIwa2l0Y2hlbiUyMGludGVyaW9yfGVufDB8fHx8MTc3OTcxNTM2Mnww&ixlib=rb-4.1.0&q=85",
    },
    {
        id: "g9",
        category: "Cuisine",
        title: "Cuisine ouverte sur séjour",
        location: "Etterbeek, Bruxelles",
        src: "https://images.unsplash.com/photo-1724582586458-a51791349977?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxiZWxnaWFuJTIwc3R5bGUlMjBtaW5pbWFsaXN0JTIwbHV4dXJ5JTIwbGl2aW5nJTIwcm9vbSUyMGludGVyaW9yfGVufDB8fHx8MTc3OTcxNTM2Mnww&ixlib=rb-4.1.0&q=85",
    },
];

export const TESTIMONIALS = [
    {
        id: "t1",
        name: "Caroline V.",
        location: "Etterbeek",
        project: "Cuisine sur mesure",
        quote:
            "Un accompagnement remarquable du premier croquis à la pose. Notre cuisine est désormais l'âme de la maison — chaque détail respire l'élégance.",
    },
    {
        id: "t2",
        name: "Julien & Anne",
        location: "Ixelles",
        project: "Dressing & chambre parentale",
        quote:
            "Une approche d'architecte, une exécution d'artisan. Le dressing s'intègre parfaitement à l'espace, comme s'il avait toujours été là.",
    },
    {
        id: "t3",
        name: "Famille D.",
        location: "Woluwe-Saint-Pierre",
        project: "Rénovation appartement",
        quote:
            "Travail rigoureux, finitions impeccables, conseils précieux. RO Concept a transformé notre appartement en lieu de vie raffiné.",
    },
];

export const PROCESS_STEPS = [
    {
        n: "01",
        title: "Prise de contact",
        text: "Échange initial pour comprendre vos envies, votre quotidien et vos contraintes.",
    },
    {
        n: "02",
        title: "Étude du projet",
        text: "Visite sur place, prises de mesures, lecture spatiale et premières orientations.",
    },
    {
        n: "03",
        title: "Conception sur mesure",
        text: "Plans détaillés, choix des matières et des finitions, présentation en 3D.",
    },
    {
        n: "04",
        title: "Fabrication",
        text: "Réalisation en atelier par nos artisans, contrôle qualité à chaque étape.",
    },
    {
        n: "05",
        title: "Installation finale",
        text: "Pose minutieuse sur site et livraison d'un espace prêt à être habité.",
    },
];

export const EXPERTISES = [
    {
        id: "e1",
        title: "Mobilier sur mesure",
        text: "Canapés, salles à manger et meubles uniques pensés selon vos espaces, vos matières et votre art de vivre.",
        image: IMAGES.furniture,
    },
    {
        id: "e2",
        title: "Cuisine personnalisée",
        text: "Des cuisines architecturales où la fonctionnalité épouse l'esthétique.",
        image: IMAGES.kitchen,
    },
    {
        id: "e3",
        title: "Dressings & rangements",
        text: "Volumes parfaitement intégrés, sur mesure pour chaque pièce de la maison.",
        image: IMAGES.dressing,
    },
];

export const WHY_US = [
    { n: "20+", label: "Années d'expérience" },
    { n: "1000+", label: "Projets livrés" },
    { n: "100%", label: "Fabrication artisanale" },
    { n: "Bxl", label: "Bruxelles & alentours" },
];
